import getters from './getters';
import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';

const state = {
  paginationItemsPerPageByTabs: {
    topLevelDomain: 20,
    infrastructure: 20,
    cloud: 20,
    cloudAccount: 20,
    employees: 20,
    technologies: 20,
    bucket: 20,
    services: 20,
    projects: 20,
    centralizedIssues: 20,
    integrations: 20,
    reports: 20,
    leaks: 20,
    infostealers: 20,
  },
  projectsPaginationState: {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  },
  centralizedIssuesPaginationState: {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  },
  integrationsPaginationState: {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  },
  servicesAssetsPaginationState: {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  },
  cloudAccountsPaginationState: {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  },
  topLevelDomainsPaginationState: {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  },
  infrastructurePaginationState: {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  },
  leaksPaginationState: {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  },
  employeesPaginationState: {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  },
  technologiesPaginationState: {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  },
  cloudInstancesPaginationState: {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  },
  cloudBucketsPaginationState: {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  },
  infostealersPaginationState: {
    page: 1,
    itemsPerPage: 20,
    total: 0,
    hasNext: false,
    hasPrevious: false,
    totalPages: 1,
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
